'use client';

import { RecurlyProvider, Elements } from '@recurly/react-recurly';
import Script from 'next/script';
import { JSX, PropsWithChildren, ReactNode, useState } from 'react';

import { DigitalWalletsProvider } from './DigitalWalletsContext';

export interface RecurlyCheckoutWrapperProps {
    children: ReactNode;
    publicKey: string;
    isDigitalWalletsEnabled: boolean;
}

export default function RecurlyCheckoutWrapper({
    publicKey,
    children,
    isDigitalWalletsEnabled,
}: PropsWithChildren<RecurlyCheckoutWrapperProps>): JSX.Element {
    const [scriptLoaded, setScriptLoaded] = useState(false);

    return (
        <div>
            <Script src="https://js.recurly.com/v4/recurly.js" onLoad={() => setScriptLoaded(true)} />
            {/* // Waiting for the script ensures these components will not load until after the necessary Recurly Script in the layout. */}
            {scriptLoaded && (
                // All components that use data from Recurly need to be encapsulated in Recurly's client-side wrapper.
                <RecurlyProvider publicKey={publicKey} required={['cvv']}>
                    <DigitalWalletsProvider isDigitalWalletsEnabled={isDigitalWalletsEnabled}>
                        <Elements>{children}</Elements>
                    </DigitalWalletsProvider>
                </RecurlyProvider>
            )}
        </div>
    );
}
